<template>
  <section class="survey-feedback mb-6 no-print">
    <template v-if="!isCompleted">
      <div class="survey-feedback__heading" v-if="title">
        <h3 :class="`${isTheRiseFrameworkSurvey ? 'mainColor--text' : ''}`">{{ title }}</h3>
      </div>
      <slot></slot>
      <div
        :class="`survey-feedback-questions ${isTheRiseFrameworkSurvey ? 'survey-feedback-questions--hide-question-names' : ''}`"
      >
        <survey-question
          v-for="question in questions"
          :key="`question-feedback-${question.id}`"
          :id="question.id"
          :title="question.title"
          :description="question.description"
          :answers="question.answers"
          :type="question.type"
          :required.sync="question.required"
          :disabled-answers="disabledAnswers"
          :disabled-questions.sync="disabledQuestions"
          :show-input-required-error.sync="showInputRequiredError"
          @handleChangeAnswer="handleChangeFeedbackAnswer"
          :is-the-rise-framework-survey="isTheRiseFrameworkSurvey"
          />
      </div>
      <v-btn
        :disabled="isLoading"
        :loading="isLoading"
        @click="onClickSubmit"
        rounded
        :color="isTheRiseFrameworkSurvey ? 'mainColor' : 'primary'"
        elevation="0"
        :class="`${isTheRiseFrameworkSurvey ? 'bhWhite--text' : ''} no-print`"
      >
        Share
      </v-btn>
    </template>
    <template v-else>
        <h3 :class="`${isTheRiseFrameworkSurvey ? 'mainColor--text' : ''}`">Thank you for sharing your feedback.</h3>
    </template>
  </section>
</template>

<script>
import { SURVEY_ANSWER_TYPES, SURVEY_QUESTION_TYPES } from '@/helpers/constants'
import SurveyQuestion from '@/components/survey/SurveyQuestion.vue'
export default {
  name: 'SurveyFeedback',
  components: {
    SurveyQuestion
  },
  props: {
    isCompleted: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: ''
    },
    isTheRiseFrameworkSurvey: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    completed: {
      type: Boolean,
      default: false
    },
    questions: {
      type: Array,
      default: () => []
    },
    icon: {
      type: String,
      default: '',
    },
    disabledAnswers: {
      type: Boolean,
      default: false,
    },
    disabledQuestions: {
      type: Array,
      default: () => [],
    },
    showInputRequiredError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      SURVEY_QUESTION_TYPES,
      SURVEY_ANSWER_TYPES
    }
  },
  computed: {
  },
  methods: {
    handleChangeFeedbackAnswer({question, answer, data, parentAnswerId, parentQuestionId, rootParentAnswerId, rootParentQuestionId, allAnswersData}) {
      this.$emit('handleChangeFeedbackAnswer', {
        question,
        answer,
        data,
        parentAnswerId,
        parentQuestionId,
        rootParentAnswerId,
        rootParentQuestionId,
        allAnswersData,
      })
    },
    onClickSubmit() {
      this.$emit('submitFeedbackSurvey')
    }
  },
}
</script>

<style lang="scss">
@import '@/styles/variables';

.survey-feedback {
  &-questions {
    &--hide-question-names {
      .survey-question__title {
        display: none;
      }
    }
  }
}
</style>
